

































































































































































































































import { Component } from '@niknevis/vue-modules'
import { Prop, Watch } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import TagsInput from '@/modules/shared/components/shared/kit/TagsInput.vue'
import { mixins } from 'vue-class-component'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import {
  DepositCollectionModelInAdmin,
  DepositCollectionWithModelInAdmin
} from '@/modules/deposit/models/deposit-collection.model'
import AdminDepositPayOffDialogTabular
  from '@/modules/deposit/components/admin/pay-dialog/AdminDepositPayOffDialogTabular.vue'
import { DepositPayOffRequestModel } from '@/modules/deposit/models/deposit-request.model'
import TesDatePicker from '@/modules/shared/components/shared/kit/TesDatePicker.vue'
import collect from 'collect.js'
import CopyableText from '@/modules/shared/components/shared/CopyableText.vue'
import { AdminDepositPayOffUseCase } from '@/modules/deposit/use-cases/admin/deposit-pay-off.use-case'
import { DateHelper } from '@/modules/shared/helpers/date'
import dayjs from 'dayjs'
import { DepositPayableType, DepositSettlementType } from '@/modules/deposit/models/deposit-resource.model'
import MediaUploader from '@/modules/media/components/shared/MediaUploader.vue'
import { BankAccountType } from '@/modules/bank-account/models/bank-account-resource.model'
import { ToggleButton } from 'vue-js-toggle-button'
import { copyText } from '@/modules/shared/helpers/utils/utils'

@Component({
  components: {
    MediaUploader,
    CopyableText,
    TesDatePicker,
    AdminDepositPayOffDialogTabular,
    CurrencyInput,
    Toggle,
    BaseInput,
    BaseSelect,
    Modal,
    BaseButton,
    TagsInput,
    ToggleButton
  }
})
export default class AdminDepositPayOffDialog extends mixins<DialogMixin>(DialogMixin) {
  constructor(
    private readonly depositPayOffUseCase: AdminDepositPayOffUseCase,
    private readonly dateHelper: DateHelper
  ) {
    super()
  }

  @Prop() deposit: DepositCollectionModelInAdmin
  @Prop() withData!: DepositCollectionWithModelInAdmin
  @Prop({ default: 'تسویه حساب' }) label: string
  private dialogModel: boolean = false
  private depositRequest: DepositPayOffRequestModel = {
    amount: this.deposit.amount || 0,
    deposit_bank_account_id: this.bankAccountId || null,
    description: this.deposit.description,
    notify_to_user: false,
    paid_at: this.deposit.paid_at || this.today,
    reception: '',
    reception_image: this.deposit.reception_image || [], //receptionImage is in depositResourceModel
    tracking_number: this.deposit.tracking_number || '',
    card_number: this.deposit.card_number || null,
    sheba: this.deposit.sheba || null,
    settlement_type: this.deposit.settlement_type || DepositSettlementType.CARD,
    account_owner_name: this.deposit.account_owner_name || '',
    account_type: this.deposit.account_type || BankAccountType.NATURAL_PERSON
  }

  depositSettlementType = DepositSettlementType
  bankAccountType = BankAccountType
  more: boolean = false
  submitTooltip: boolean = false
  numberCopyTooltip: boolean = false

  //Mounted---------------------
  mounted() {
    this.depositRequest.reception = this.receptionText()
  }

  //Setter Getter------------------
  get _settlementType() { //card=true sheba:false
    return this.isCard
  }

  set _settlementType(value) { //card=true sheba:false
    this.depositRequest.settlement_type = (value) ? DepositSettlementType.CARD : DepositSettlementType.SHEBA
  }

  protected setValue(key, value) {
    this.$set(this.depositRequest, key, value)
  }

  get idOptions() {
    return collect(this.withData.deposit_bank_accounts).map((item) => ({
      label: item.title,
      value: item.id
    })).toArray()
  }

  get accountTypeOptions() {
    return collect(this.withData.account_types).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }

  get today(): string {
    let time = `${new Date().getHours()}:${new Date().getMinutes()}`
    return this.dateHelper.fromJalali(dayjs().format('YYYY/MM/DD') + ` ${time}`, 'YYYY/MM/DD HH:MM').toTimestamp()
  }

  get bankAccountId(): number {
    if (this.deposit.account_type === BankAccountType.NATURAL_PERSON)
      return this.withData.deposit_bank_accounts.find(obj => {
        return (obj.account_type === BankAccountType.NATURAL_PERSON && obj.default === 1)
      })?.id
    else if (this.deposit.account_type === BankAccountType.LEGAL_PERSON)
      return this.withData.deposit_bank_accounts.find(obj => {
        return (obj.account_type === BankAccountType.LEGAL_PERSON && obj.default === 1)
      })?.id
    else return null
  }

  get isCard() {
    return this.depositRequest.settlement_type === DepositSettlementType.CARD
  }

  get isSheba() {
    return this.depositRequest.settlement_type === DepositSettlementType.SHEBA
  }

  get isCheque() {
    return this.depositRequest.settlement_type === DepositSettlementType.CHEQUE
  }

  get hasSheba() {
    return Boolean(this.depositRequest.sheba)
  }

  get amountSeparator() {
    return this.depositRequest.amount.toLocaleString()
  }

  //------------
  @Watch('depositRequest', { immediate: true, deep: true })
  onChange() {
    this.depositRequest.reception = this.receptionText()
  }

  //Methods------------------------
  show() {
    this.dialogModel = true
  }

  onSubmit() {
    //doCopy
    this.copy(this.depositRequest.reception)
    this.receptionShowTooltip()
    //
    this.depositPayOffUseCase.execute(this.deposit.id, this.depositRequest)
      .then(() => {
        if (this.depositPayOffUseCase.isSuccess) {
          this.dialogModel = false
        }
      })
  }

  onNumberCopy() {
    this.numberCopyTooltip = true
    setTimeout(() => this.numberCopyTooltip = false, 2000);
    (this.isCard) ? this.copy(this.depositRequest.card_number) : this.copy(this.depositRequest.sheba)
  }

  copy(value) {
    copyText(value)
  }

  receptionText() {
    return (`${this.isUser()} گرامی
پرداختی شما با مشخصات زیر انجام شد
عنوان : ${this.deposit.title || 'ندارد'} ${(!(this.deposit.payable_type === 'User') ? `(${this.withData.payable_types[this.deposit.payable_type]})` : '')}
مبلغ : ${this.amountSeparator} تومان
شماره پیگیری : ${this.depositRequest.tracking_number || 'ندارد'}
شماره ${(this.isCard) ? 'کارت' : 'شبا'} : ${this.hasSheba && this.isSheba ? 'IR' : ''}${this.depositRequest[`${(this.isCard) ? 'card_number' : 'sheba'}`] || 'ندارد'}
نام صاحب حساب : ${this.depositRequest.account_owner_name || 'ندارد'}
نوع حساب : ${(this.depositRequest.account_type === BankAccountType.LEGAL_PERSON) ? 'حقوقی' : 'حقیقی' || 'ندارد'}
تاریخ : ${this.jalaliData(this.depositRequest.paid_at)}
توضیحات : ${this.depositRequest.description || 'ندارد'}`) || ''
  }

  receptionShowTooltip() {
    this.submitTooltip = true
    setTimeout(() => this.submitTooltip = false, 2000)
  }

  jalaliData(value): string {
    return (value) ? dayjs(value).format('HH:mm YYYY/MM/DD') : 'ندارد'
  }

  isUser(): string {
    if (this.deposit.payable_type === DepositPayableType.USER)
      return 'کاربر'
    else return 'انتشاردهنده'
  }
}
